<svelte:options runes={true} />
<script lang="ts">import { marked } from 'marked';
import DOMPurify from 'dompurify';
let { source = '' } = $props();
let html = $derived(DOMPurify.sanitize(marked.parse(source !== null && source !== void 0 ? source : '')));
</script>

{@html html}
